// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"799":"4a2a4d5c","889":"7379358a"}[chunkId] + ".js";
};